import { FetchedWasteTypes } from "@/Utils/api/sanity/types";

export const getWasteTypeIcon = (
  fractionId: string,
  wasteTypes: FetchedWasteTypes,
) => {
  return (
    (wasteTypes?.find((wt) => wt.id === fractionId)?.iconColor as string) ||
    "Unknown id"
  );
};
